"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2cImpactStats = exports.b2bImpactStats = void 0;
exports.b2bImpactStats = {
    medium: {
        tier1: {
            carbon: 0.3334,
            carbonAnnual: 4,
            trees: 2,
            footprints: 0.5,
        },
        tier2: {
            carbon: 0.6667,
            carbonAnnual: 8,
            trees: 4,
            footprints: 1,
        },
        tier3: {
            carbon: 1.3334,
            carbonAnnual: 16,
            trees: 8,
            footprints: 2,
        },
    },
    high: {
        tier1: {
            carbon: 0.7084,
            carbonAnnual: 8.5,
            trees: 3,
            footprints: 0.5,
        },
        tier2: {
            carbon: 1.4167,
            carbonAnnual: 17,
            trees: 6,
            footprints: 1,
        },
        tier3: {
            carbon: 2.8334,
            carbonAnnual: 34,
            trees: 12,
            footprints: 2,
        },
    },
};
exports.b2cImpactStats = {
    medium: {
        personal: {
            carbon: 0.22,
            carbonAnnual: 2.64,
            trees: 2,
            footprints: 0.33,
        },
        booster: {
            carbon: 0.6667,
            carbonAnnual: 8,
            trees: 4,
            footprints: 1,
        },
        mega: {
            carbon: 1.3334,
            carbonAnnual: 16,
            trees: 8,
            footprints: 2,
        },
        children: {
            carbon: 0.11,
            carbonAnnual: 1.32,
            trees: 1,
            footprints: 0.165,
        },
        pets: {
            carbon: 0.05,
            carbonAnnual: 0.6,
            trees: 0,
            footprints: 0,
        },
    },
    high: {
        personal: {
            carbon: 0.3542,
            carbonAnnual: 4.25,
            trees: 3,
            footprints: 0.25,
        },
        booster: {
            carbon: 0.7084,
            carbonAnnual: 8.5,
            trees: 6,
            footprints: 0.5,
        },
        mega: {
            carbon: 1.4167,
            carbonAnnual: 17,
            trees: 12,
            footprints: 1,
        },
        children: {
            carbon: 0.1771,
            carbonAnnual: 2.125,
            trees: 2,
            footprints: 0.125,
        },
        pets: {
            carbon: 0.05,
            carbonAnnual: 0.6,
            trees: 0,
            footprints: 0,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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